import { render, staticRenderFns } from "./home.vue?vue&type=template&id=62c04a3e&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./home.vue?vue&type=style&index=1&id=62c04a3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c04a3e",
  null
  
)

export default component.exports